(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('.sale-bar');
    if (!bar) return;

    var endTime = new Date(bar.dataset.endDatetime).getTime();
    if (isNaN(endTime)) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function update() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        bar.remove();
        clearInterval(interval);
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      bar.querySelectorAll('[data-day-group]').forEach(function (el) {
        el.style.display = days > 0 ? '' : 'none';
      });
      bar.querySelectorAll('[data-unit="days"]').forEach(function (el) {
        el.textContent = pad(days);
      });
      bar.querySelectorAll('[data-unit="hours"]').forEach(function (el) {
        el.textContent = pad(hours);
      });
      bar.querySelectorAll('[data-unit="minutes"]').forEach(function (el) {
        el.textContent = pad(minutes);
      });
      bar.querySelectorAll('[data-unit="seconds"]').forEach(function (el) {
        el.textContent = pad(seconds);
      });
    }

    update();
    var interval = setInterval(update, 1000);
  });
})();
